module.exports = __webpack_public_path__ + "d4c9a2b92aeb40e4cc97227bf3dd9018.svg";